const $inject = ['$scope', '$routeParams', '$timeout', 'dataService'];

const lbaRangeCtrl = function ($scope, $routeParams, $timeout, dataService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

  if (vm.settings.divideResultBy > 0) {
    vm.divideResult = true;
  }

  vm.rangeModel = 0;
  vm.min = vm.settings.min || 0;
  vm.max = vm.settings.max || 10000000000;
  vm.step = vm.settings.step || 1;
  vm.units = vm.settings.units || '';

  vm.updateModel = updateModel;


  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });


  const data = _.get(dataService.data.activeItem, dataLookUp);
  vm.data = _.isUndefined(data) && _.isNumber(vm.settings.defaultValue) ? vm.settings.defaultValue : data;
  
  if (vm.settings.defaultValue) {
    _.set(dataService.data.activeItem, dataLookUp, vm.data)
  }

  $timeout(() => {
    if (vm.divideResult) {
      vm.rangeModel = vm.data * vm.settings.divideResultBy;
    } else {
      vm.rangeModel = vm.data;
    }
  });

  function updateModel() {
    if (vm.divideResult) {
      vm.data = vm.rangeModel / vm.settings.divideResultBy;
    } else {
      vm.data = vm.rangeModel;
    }
  }
};

lbaRangeCtrl.$inject = $inject;

export default lbaRangeCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaRange/lbaRangeCtrl.js